"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.preview.title': 'Podgląd Testu Bota',
    'botTest.preview.run': 'Uruchom Test',
    'botTest.preview.edit': 'Edytuj Test',
    'botTest.preview.back': 'Powrót do Listy',
    'botTest.preview.section.basic_info': 'Podstawowe Informacje',
    'botTest.preview.section.statistics': 'Statystyki',
    'botTest.preview.section.testers': 'Konfiguracja Testów',
    'botTest.preview.not_provided': 'Nie podano',
    'botTest.preview.total_testers': 'Łączna liczba testerów',
    'botTest.preview.total_targets': 'Łączna liczba celów',
    'botTest.preview.creator': 'Utworzono przez',
    'botTest.preview.unknown_creator': 'Nieznany',
    'botTest.preview.testers_count': 'Testerzy',
    'botTest.preview.targets_count': 'Cele',
    'botTest.preview.created_date': 'Utworzono',
    'botTest.preview.updated_date': 'Ostatnia aktualizacja',
    'botTest.preview.tester_configuration': 'Konfiguracja Testera',
    'botTest.preview.prompt_overridden': 'Prompt nadpisany',
    'botTest.preview.no_targets': 'Brak skonfigurowanych celów',
    'botTest.preview.unknown_avatar': 'Nieznany awatar',
    'botTest.preview.no_testers': 'Brak skonfigurowanych testerów',
    'botTest.preview.no_testers_description': 'Dodaj testerów, aby skonfigurować modele AI i prompty do testowania.',
    'botTest.preview.not_found': 'Test bota nie znaleziony',
    'botTest.preview.not_found_description': 'Żądany test bota nie mógł zostać znaleziony lub został usunięty.',
    'botTest.preview.no_model': 'Brak modelu',
    'botTest.preview.unknown_model': 'Nieznany model',
    'botTest.preview.status.unknown': 'Nieznany',
    'botTest.preview.status.active': 'Aktywny',
    'botTest.preview.status.inactive': 'Nieaktywny',
    'botTest.preview.status.standby': 'Oczekuje',
    'botTest.preview.status.pending': 'Oczekujący',
    'botTest.preview.status.running': 'W trakcie',
    'botTest.preview.status.completed': 'Zakończony',
    'botTest.preview.status.failed': 'Niepowodzenie',
    'botTest.preview.error.load_failed': 'Nie udało się załadować testu bota',
    'botTest.preview.run_confirmation': 'Czy na pewno chcesz uruchomić ten test?',
    'botTest.preview.run_started': 'Test bota uruchomiony pomyślnie',
    'botTest.preview.run_failed': 'Nie udało się uruchomić testu bota',
    'botTest.preview.tabs.data': 'Dane',
    'botTest.preview.tabs.test_results': 'Wyniki testów',
    'botTest.preview.section.test_results': 'Wyniki testów',
    'botTest.preview.no_test_results': 'Brak wyników testów',
    'botTest.preview.no_test_results_description': 'Uruchom test bota, aby zobaczyć wyniki tutaj.',
    'botTest.preview.model': 'Model',
    'botTest.preview.temperature': 'Temperatura',
    'botTest.preview.completed': 'Zakończone',
    'botTest.preview.failed': 'Nieudane',
    'botTest.preview.status': 'Status',
    'botTest.preview.messages': 'Wiadomości',
    'botTest.preview.tokens': 'Tokeny',
    'botTest.preview.duration': 'Czas trwania',
    'botTest.preview.total_messages': 'Wszystkie wiadomości',
    'botTest.preview.total_tokens': 'Wszystkie tokeny',
    'botTest.preview.avg_duration': 'Śr. czas trwania',
};
